import { useEffect } from "react";

export default function SEOHead({ title, description, canonical, schema }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    if (canonical) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) {
        l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        document.head.appendChild(l);
      }
      l.setAttribute("href", canonical);
    }
    let s = document.getElementById("page-schema");
    if (s) s.remove();
    if (schema) {
      const tag = document.createElement("script");
      tag.id = "page-schema";
      tag.type = "application/ld+json";
      tag.text = JSON.stringify(schema);
      document.head.appendChild(tag);
    }
  }, [title, description, canonical, schema]);
  return null;
}
